export default __webpack_public_path__ + "static/media/colombia.7add4dd9.svg";